import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';
import {
    PROFILE_FETCH,
    PROFILE_FETCH_SUCCESS,
    PROFILE_SAVE,
    PROFILE_REMOVE,
    PROFILE_SAVE_SUCCESS,
    PROFILE_ERASE,
    PROFILE_FETCH_REPORT_ADDRESSES,
    PROFILE_SAVE_CURRENT_ADDRESS,
    PROFILE_SEND_USER_DATA,
    PROFILE_SEND_USER_DATA_UNVERIFIED_EMAIL,
    PROFILE_RESEND_EMAIL_VERIFICATION,
    PROFILE_MKTG_PREF_FETCH,
    PROFILE_MKTG_PREF_SAVE,
    PROFILE_SAVE_TERMS,
} from '@clearscore/constants.profile-action-types';

// PROFILE_FETCH
export const fetch = () => createAction(PROFILE_FETCH, createRequestPayload('international', '/profile-service/v2/'));

// PROFILE_FETCH_SUCCESS
// @todo: this seems to only needed for the angular integration
export const fetchSuccess = (profileData) => createAction(PROFILE_FETCH_SUCCESS, profileData);

// PROFILE_SAVE
export const save = (profile) =>
    createAction(PROFILE_SAVE, createRequestPayload('international', '/profile-service/v2/', 'patch', profile));

export const remove = () =>
    createAction(PROFILE_REMOVE, createRequestPayload('caesium', '/accounts/@session.auth.accountId', 'delete'));

export const erase = () =>
    createAction(PROFILE_ERASE, createRequestPayload('international', '/profile-service/v2/', 'delete'));

// PROFILE_SAVE_SUCCESS
// @todo: this seems to only needed for the angular integration
export const saveSuccess = (profileData) => createAction(PROFILE_SAVE_SUCCESS, profileData);

// PROFILE_FETCH_REPORT_ADDRESSES
export const fetchReportAddresses = () =>
    createAction(
        PROFILE_FETCH_REPORT_ADDRESSES,
        createRequestPayload('international', '/profile-service/v2/report/credit-report-address'),
    );

// PROFILE_SAVE_CURRENT_ADDRESS
export const saveCurrentAddress = (addressId) =>
    createAction(
        PROFILE_SAVE_CURRENT_ADDRESS,
        createRequestPayload('international', `/profile-service/v2/account/current-address/${addressId}`, 'put'),
    );

// PROFILE_SEND_USER_DATA
export const sendUserData = () =>
    createAction(
        PROFILE_SEND_USER_DATA,
        createRequestPayload('international', '/profile-service/v1/send-user-data', 'post'),
    );

// PROFILE_RESEND_EMAIL_VERIFICATION
export const resendEmailVerification = ({ email }) =>
    createAction(
        PROFILE_RESEND_EMAIL_VERIFICATION,
        createRequestPayload('international', '/profile-service/v2/resend-email-verification', 'post', { email }),
    );

// PROFILE_SEND_USER_DATA_UNVERIFIED_EMAIL
export const sendUserDataUnverifiedEmail = () => createAction(PROFILE_SEND_USER_DATA_UNVERIFIED_EMAIL);

export const fetchMarketingPreferences = () =>
    createAction(
        PROFILE_MKTG_PREF_FETCH,
        createRequestPayload('international', '/profile-service/v2/marketing-preferences'),
    );

export const saveMarketingPreferences = (mktgPreferences) =>
    createAction(
        PROFILE_MKTG_PREF_SAVE,
        createRequestPayload('international', '/profile-service/v2/marketing-preferences', 'patch', mktgPreferences),
    );

// this action has been created to not conflict with profile save functionality in other verticals
export const saveTerms = (profile) =>
    createAction(PROFILE_SAVE_TERMS, createRequestPayload('international', '/profile-service/v2/', 'patch', profile));
